import CreateCDActionTypes from './createCD.types';

import { editCDInfoFromList } from './createCD.utils';

const INITIAL_STATE = {
  editingId: null,
  selectedCampaign: null,
  maximumDueDate: {
    periodDays: 0,
    periodMonths: 0
  },
  cdInfo: null,
  cdDefaultInfo: null,
  hasCDDefaultInfo: false,
  cdList: [],
  messengerOrderId: null,
  cdId: 0,
  requestVoucher: false
};

const createCDReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CreateCDActionTypes.SET_EDITING_ID:
      return {
        ...state,
        editingId: action.payload
      };
    case CreateCDActionTypes.CLEAR_EDITING_ID:
      return {
        ...state,
        editingId: null
      };
    case CreateCDActionTypes.SET_SELECTED_CAMPAIGN:
      return {
        ...state,
        selectedCampaign: action.payload
      };
    case CreateCDActionTypes.SET_MAXIMUM_DUE_DATE:
      return {
        ...state,
        maximumDueDate: {
          ...state.maximumDueDate,
          ...action.payload
        }
      };
    case CreateCDActionTypes.CLEAR_SELECTED_CAMPAIGN:
      return {
        ...state,
        selectedCampaign: null
      };
    case CreateCDActionTypes.SET_CD_DEFAULT_INFO:
      return {
        ...state,
        cdDefaultInfo: action.payload,
        hasCDDefaultInfo: action.payload ? true : false
      };
    case CreateCDActionTypes.SET_CD_INFO:
      return {
        ...state,
        cdInfo: {
          ...state.cdInfo,
          ...action.payload
        }
      };
    case CreateCDActionTypes.RESET_CD_INFO:
      return {
        ...state,
        cdInfo: null
      };
    case CreateCDActionTypes.ADD_NEW_CD:
      return {
        ...state,
        cdList: [...state.cdList, action.payload]
      };
    case CreateCDActionTypes.SET_CD_LIST:
      return {
        ...state,
        cdList: action.payload
      };
    case CreateCDActionTypes.EDIT_CD_INFO:
      return {
        ...state,
        cdList: editCDInfoFromList(
          state.cdList,
          state.editingId,
          action.payload
        )
      };
    case CreateCDActionTypes.SET_CD_ID:
      return {
        ...state,
        cdId: parseInt(action.payload)
      };
    case CreateCDActionTypes.SET_REQUEST_VOUCHER:
      return {
        ...state,
        requestVoucher: action.payload
      };

    // FOR messenger order
    case CreateCDActionTypes.SET_MESSENGER_ORDER_ID:
      return {
        ...state,
        messengerOrderId: parseInt(action.payload)
      };
    default:
      return state;
  }
};

export default createCDReducer;
